<template>
  <div class="setComponent">
    <!-- 表单 -->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form-setting" size="medium">
      <div class="title">
        <h4>{{ titleText }}</h4>
        <el-divider></el-divider>
      </div>
      <el-form-item :label="$i18n.t('wm_lang_d26ecc')" prop="popEmail">
        <el-input v-model="ruleForm.popEmail"></el-input>
        <p class="f12 c_blue">{{$t("wm_lang_html_614fc6")}}name@example.com{{$t("wm_lang_html_026601")}}</p>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_9e4d59')" prop="popPasswd">
        <el-input type="password" v-model="ruleForm.popPasswd"></el-input>
      </el-form-item>
      <el-form-item :label="'POP'+$i18n.t('wm_lang_c566ca')" prop="popHost">
        <el-input v-model="ruleForm.popHost"></el-input>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_39c764')" prop="popPort">
        <el-input v-model="ruleForm.popPort"></el-input>
        <el-checkbox :label="'SSL'+$i18n.t('wm_lang_30f7dd')" name="type" v-model="ruleForm.sslEnable" @change.native="sslChange"></el-checkbox>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_827d98')" prop="folderId">
        <el-select v-model="ruleForm.folderId" :placeholder="$i18n.t('wm_lang_e75969')">
          <el-option v-for="(item, index) in folders" :key="index" :label="item.displayName" :value="item.folderId" style="max-width:274px;"></el-option>
        </el-select>
      </el-form-item>
    <br><br>
    <div class="title">
      <h4>{{$t("wm_lang_html_3be506")}}</h4>
      <el-divider></el-divider>
    </div>
      <el-form-item :label="$i18n.t('wm_lang_c4c3f3')" prop="discardEnable">
        <el-switch v-model="ruleForm.discardEnable"></el-switch>
      </el-form-item>
      <el-form-item :label="$i18n.t('wm_lang_3caa33')" prop="status">
        <el-switch v-model="ruleFormStatus"></el-switch>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t("wm_lang_html_be5fbb")}}</el-button>
        <el-button @click="cancelForm">{{$t("wm_lang_html_625fb2")}}</el-button>
      </el-form-item>
    </el-form>
    <br><br>
  </div>
</template>

<script>
import xmail from '@/api/api';
import { isEmail } from '@/utils/validate';
import { rsaEncrypt } from '@/utils/utils';
import debounce from '@/utils/debounce'

export default {
  name: 'addEmailAccount',
  data () {
    const isEmpty = function(info) {
      return (rule, value, callback) => {
        if (value == '') {
          callback(new Error(info));
        }
        callback();
      }
    };
    const validateEmail = (rule, value, callback) => {
      if (!/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(value)) {
        callback(new Error(this.$i18n.t('wm_lang_561caa')+','+this.$i18n.t('wm_lang_a8424d')));
      }
      callback();
    };
    const validatePort = (rule, value, callback) => {
      if (!/^[0-9]+$/.test(value) || parseInt(value) > 65535 || parseInt(value) < 1) {
        callback(new Error(this.$i18n.t('wm_lang_561caa')+','+this.$i18n.t('wm_lang_a8424d')));
      }
      callback();
    };
    const validatePassHost = function(info) {
      return (rule, value, callback) => {
        if (value.length > 64) {
          callback(new Error(info));
        }
        callback()
      }
    }

    return {
      folders: [],
      ruleFormStatus: true,
      oldPopEmail: '',
      ruleForm: {
        popEmail: "",
        popPasswd: "",
        popHost: "",
        popPort: 110,
        sslEnable: false,
        discardEnable: true,
        folderId: 1,
        status: 1
      },
      titleText: this.$i18n.t('wm_lang_a46aa1'),
      rules: {
        popHost: [
          { required: true, trigger: 'blur', validator: isEmpty('POP'+this.$i18n.t('wm_lang_211cfb')) },
          { trigger: 'blur', validator: validatePassHost('POP'+this.$i18n.t('wm_lang_306a2a')+'64'+this.$i18n.t('wm_lang_15d410')) }
        ],
        popEmail: [
          { required: true, trigger: 'blur', validator: isEmpty(this.$i18n.t('wm_lang_5ee1ff')) },
          { trigger: 'blur', validator: validateEmail }
        ],
        popPasswd: [
          { required: true, trigger: 'blur', validator: isEmpty(this.$i18n.t('wm_lang_199536')) },
          { trigger: 'blur', validator: validatePassHost(this.$i18n.t('wm_lang_3cec17')+'64'+this.$i18n.t('wm_lang_15d410')) }
        ],
        popPort: [
          { required: true, trigger: 'blur', validator: isEmpty(this.$i18n.t('wm_lang_01468d')) },
          { trigger: 'blur', validator: validatePort }
        ],
      }
    }
  },
  mounted() {
    this.getFolders();
    let popEmail = this.$route.params.popEmail;
    if(popEmail) {
      this.oldPopEmail = popEmail;
      this.titleText = this.$i18n.t('wm_lang_e8ed1b');
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Pop.queryMailPopInfoParamBuilder();
        pm.popEmail = popEmail;
        api.Pop.queryMailPopInfo(pm, function (res) {
          console.log('res.data')
          console.log(res.data);
          self.ruleForm = res.data.data;
          self.ruleForm.discardEnable = !self.ruleForm.discardEnable;
          self.ruleFormStatus = self.ruleForm.status === xmail.enums.PopEmalStatus.ENABLE;
        })
      })(xmail.api, xmail.enums, xmail.pms);
    }
  },
  methods: {
    getFolders() {
      this.folders = this.$store.getters.folders;
      this.folders = this.folders.filter(item => item.folderId !== xmail.enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== xmail.enums.FolderType.WAITING_BOX_FOLDER_ID)
      // console.log('this.folders')
      // console.log(this.folders)
    },
    sslChange() {
      if(this.ruleForm.sslEnable) {
        this.ruleForm.popPort = 995
      } else {
        this.ruleForm.popPort = 110
      }
    },
    cancelForm() {
      this.$router.push({name: 'otherEmailAccount'});
    },
    submitForm(formName) {
      debounce(() => {
        this.$refs[formName].validate((valid) => {
          console.log(valid)
          if (valid) {
            let self = this;
            (function (api, enums, pms) {
              let lastValue = self.ruleForm.popPasswd;
              self.ruleForm.popPasswd = rsaEncrypt(self.ruleForm.popPasswd);
              let pm = self.ruleForm;
              if(self.ruleFormStatus) {
                self.ruleForm.status = xmail.enums.PopEmalStatus.ENABLE;
              } else {
                self.ruleForm.status = xmail.enums.PopEmalStatus.DISABLE;
              }
              // console.log(pm);
              // return;
              let popEmail = self.$route.params.popEmail;
              if(popEmail) {
                self.$message({
                  type: 'info',
                  message: self.$i18n.t('wm_lang_3755ef')
                });
                pm = {
                  ...pm,
                  oldPopEmail: self.oldPopEmail,
                  discardEnable: !self.ruleForm.discardEnable
                };
                console.log(pm)
                api.Pop.updateMailPopInfo(pm, function (res) {
                  // console.log(res)
                  if(res.data.code === 0) {
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_8347a9')+'pop'+self.$i18n.t('wm_lang_330363')
                    });
                    self.$router.push({name: 'otherEmailAccount'});
                  }
                })
              } else {
                self.$message({
                  type: 'info',
                  message: self.$i18n.t('wm_lang_3755ef')
                });
                pm = {
                  ...pm,
                  discardEnable: !self.ruleForm.discardEnable
                };
                api.Pop.addMailPopInfo(pm, function (res) {
                  // console.log(res)
                  if(res.data.code === 0) {
                    self.$message({
                      type: 'success',
                      message: self.$i18n.t('wm_lang_d9e569')
                    });
                    self.$router.push({name: 'otherEmailAccount'});
                  }
                })
              }
              self.ruleForm.popPasswd = lastValue; //将密码置回未加密状态，方便下次提交
            })(xmail.api, xmail.enums, xmail.pms);
          } else {
            this.$message({
              type: 'info',
              message: this.$i18n.t('wm_lang_2456c8')
            })
            return false;
          }
        });
      }, 1000)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .setComponent{padding:10px;}
 .setComponent .title .el-divider--horizontal{margin:10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/views/setBox/addEmailAccount.vue